import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { signOut } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Timestamp } from 'firebase/firestore';
import { collection, query, where, getDocs, doc, updateDoc, addDoc, serverTimestamp, writeBatch, deleteDoc } from 'firebase/firestore';
import ImportWishlist from "./ImportWishlist";
import CopyNeedsTool from "./CopyNeedsTool";
import { CFR_CATEGORIES } from "../../constants/cfrCategories";

const ST = {
  page: { minHeight: '100vh', background: '#f9fafb', fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif' },
  header: { background: 'white', borderBottom: '1px solid #eee', padding: '0 2rem', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 },
  logo: { fontSize: '1.2rem', fontWeight: 700, color: '#1a1a1a' },
  main: { maxWidth: '1100px', margin: '0 auto', padding: '2rem' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', marginBottom: '2rem' },
  statCard: { background: 'white', borderRadius: '12px', padding: '1.25rem 1.5rem', border: '1px solid #eee' },
  statNum: { fontSize: '2rem', fontWeight: 700, color: '#1a1a1a', lineHeight: 1, marginBottom: '0.25rem' },
  statLabel: { fontSize: '0.85rem', color: '#888' },
  tabs: { display: 'flex', marginBottom: '1.5rem', borderBottom: '1px solid #eee' },
  tab: { padding: '0.6rem 1.25rem', cursor: 'pointer', fontSize: '0.9rem', color: '#555', border: 'none', background: 'transparent', borderBottom: '2px solid transparent', marginBottom: '-1px', fontWeight: 500 },
  tabActive: { color: '#1a1a1a', borderBottomColor: '#1a1a1a' },
  card: { background: 'white', borderRadius: '12px', padding: '1.25rem 1.5rem', border: '1px solid #eee', marginBottom: '1rem' },
  orgName: { fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.25rem' },
  orgMeta: { fontSize: '0.85rem', color: '#888', marginBottom: '0.75rem' },
  orgDetail: { fontSize: '0.9rem', color: '#444', marginBottom: '0.5rem', lineHeight: 1.5 },
  btnRow: { display: 'flex', gap: '0.75rem', marginTop: '1rem' },
  btnApprove: { background: '#2d6a4f', color: 'white', border: 'none', padding: '0.5rem 1.25rem', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' },
  btnReject: { background: 'transparent', color: '#dc2626', border: '1px solid #dc2626', padding: '0.5rem 1.25rem', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' },
  btnSignout: { background: 'transparent', border: '1px solid #ddd', padding: '0.4rem 0.875rem', borderRadius: '6px', fontSize: '0.85rem', cursor: 'pointer', color: '#555' },
  btnMatch: { background: '#1e3a5f', color: 'white', border: 'none', padding: '0.5rem 1.25rem', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' },
  btnCancel: { background: 'transparent', color: '#555', border: '1px solid #ddd', padding: '0.5rem 1.25rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  badge: { display: 'inline-block', padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 700 },
  empty: { textAlign: 'center', padding: '3rem', color: '#888', fontSize: '0.95rem' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' },
  lbl: { fontSize: '0.8rem', color: '#555', display: 'block', marginBottom: '0.25rem' },
  inp: { width: '100%', padding: '0.5rem 0.75rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.9rem', boxSizing: 'border-box' },
  fullRow: { marginBottom: '0.75rem' },
  donorPrice: { fontSize: '0.9rem', color: '#2d6a4f', fontWeight: 700, marginBottom: '1rem', padding: '0.5rem 0.75rem', background: '#d1fae5', borderRadius: '6px', display: 'inline-block' }
};


 
function AdminCfrPicker({ selected, onChange }) {
  function toggle(value) {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else if (selected.length < 3) {
      onChange([...selected, value]);
    }
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginTop: '0.25rem' }}>
      {CFR_CATEGORIES.map(cat => {
        const active = selected.includes(cat.value);
        const atMax = selected.length >= 3 && !active;
        return (
          <button
            key={cat.value}
            type="button"
            disabled={atMax}
            onClick={() => toggle(cat.value)}
            style={{
              padding: '0.25rem 0.7rem',
              borderRadius: '20px',
              fontSize: '0.78rem',
              fontWeight: 600,
              cursor: atMax ? 'default' : 'pointer',
              border: active ? 'none' : '1px solid #ddd',
              background: active ? '#1e3a5f' : atMax ? '#f5f5f5' : 'white',
              color: active ? 'white' : atMax ? '#bbb' : '#555',
            }}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
}

function NeedEditForm({ need, onSave, onCancel, editForm, setEditForm,
  splitNeed, splitUnits, setSplitUnits, splitUnitPrice, setSplitUnitPrice }) {
  return (
    <>
      <div style={{ fontSize: '0.85rem', fontWeight: 700, marginBottom: '1rem' }}>Editing: {need.itemName}</div>
      
<div style={ST.fullRow}>
  <label style={ST.lbl}>Need type</label>
  <select
    value={editForm.type || 'supply'}
    onChange={e => setEditForm(prev => ({ ...prev, type: e.target.value }))}
    style={ST.inp}
  >
    <option value="supply">Supply</option>
    <option value="sponsorship">Sponsorship</option>
  </select>
</div>

      <div style={ST.grid2}>
        <div><label style={ST.lbl}>Item name</label><input value={editForm.itemName} onChange={e => setEditForm(prev => ({ ...prev, itemName: e.target.value }))} style={ST.inp} /></div>
        <div><label style={ST.lbl}>Priority</label>
          <select value={editForm.priority} onChange={e => setEditForm(prev => ({ ...prev, priority: e.target.value }))} style={ST.inp}>
            <option value="critical">Critical</option>
            <option value="core">Core</option>
            <option value="supplemental">Supplemental</option>
          </select>
        </div>
      </div>
      <div style={ST.fullRow}><label style={ST.lbl}>Description</label><textarea value={editForm.description} onChange={e => setEditForm(prev => ({ ...prev, description: e.target.value }))} style={{ ...ST.inp, minHeight: '70px', resize: 'vertical', fontFamily: 'inherit' }} /></div>

      <div style={ST.fullRow}>
        <label style={ST.lbl}>Community Priority (CFR) — up to 3</label>
        <AdminCfrPicker
          selected={editForm.cfrCategories || []}
          onChange={val => setEditForm(prev => ({ ...prev, cfrCategories: val }))}
        />
      </div>      

      <div style={ST.grid2}>
        <div><label style={ST.lbl}>Frequency</label>
          <select value={editForm.frequency} onChange={e => setEditForm(prev => ({ ...prev, frequency: e.target.value }))} style={ST.inp}>
            <option value="monthly">Monthly</option>
            <option value="bi-monthly">Bi-monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="one-time">One-time</option>
          </select>
        </div>
        <div style={ST.grid2}>


  <div>
    <label style={ST.lbl}>Preferred delivery day</label>
    <input
      type="number"
      min="1"
      max="28"
      value={editForm.preferredDeliveryDay || ''}
      onChange={e => setEditForm(prev => ({
        ...prev,
        preferredDeliveryDay: e.target.value
      }))}
      style={ST.inp}
    />
  </div>
</div>
        <div><label style={ST.lbl}>Quantity</label><input type="number" value={editForm.quantityPerCycle} onChange={e => setEditForm(prev => ({ ...prev, quantityPerCycle: e.target.value }))} style={ST.inp} /></div>
      </div>
      <div style={ST.grid2}>
        <div><label style={ST.lbl}>People served</label><input type="number" value={editForm.impactQuantity} onChange={e => setEditForm(prev => ({ ...prev, impactQuantity: e.target.value }))} style={ST.inp} /></div>
        <div><label style={ST.lbl}>What they receive</label><input value={editForm.impactUnit} onChange={e => setEditForm(prev => ({ ...prev, impactUnit: e.target.value }))} style={ST.inp} /></div>
      </div>
      {editForm.impactQuantity && editForm.impactUnit && (
        <div style={{ fontSize: '0.85rem', color: '#555', marginBottom: '0.75rem', fontStyle: 'italic' }}>
          Preview: "One delivery provides {editForm.impactQuantity} {editForm.impactUnit}"
        </div>
      )}
      <div style={ST.grid2}>
        <div><label style={ST.lbl}>Base cost ($)</label><input type="number" step="0.01" value={editForm.baseCost} onChange={e => setEditForm(prev => ({ ...prev, baseCost: e.target.value }))} style={ST.inp} /></div>
        <div><label style={ST.lbl}>Markup %</label><input type="number" value={editForm.markupPct} onChange={e => setEditForm(prev => ({ ...prev, markupPct: e.target.value }))} style={ST.inp} /></div>
      </div>
      <div style={ST.grid2}>
        <div><label style={ST.lbl}>Donor price ($)</label><input type="number" step="0.01" value={editForm.pricePerCycle} onChange={e => setEditForm(prev => ({ ...prev, pricePerCycle: e.target.value }))} style={ST.inp} /></div>
        <div><label style={ST.lbl}>Status</label>
          <select value={editForm.status} onChange={e => setEditForm(prev => ({ ...prev, status: e.target.value }))} style={ST.inp}>
            <option value="open">Open</option>
            <option value="funded">Funded</option>
            <option value="paused">Paused</option>
            <option value="pending_match">Pending match</option>
            <option value="discontinued">Discontinued</option>
          </select>
        </div>
      </div>
      <div style={ST.fullRow}><label style={ST.lbl}>Vendor</label><input value={editForm.vendorName} onChange={e => setEditForm(prev => ({ ...prev, vendorName: e.target.value }))} style={ST.inp} /></div>
      <div style={ST.fullRow}><label style={ST.lbl}>Product URL</label><input value={editForm.vendorProductUrl} onChange={e => setEditForm(prev => ({ ...prev, vendorProductUrl: e.target.value }))} style={ST.inp} /></div>
      <div style={ST.btnRow}>
        <div style={ST.btnRow}>
  <button style={ST.btnApprove} onClick={onSave}>Save changes</button>
  <button style={ST.btnCancel} onClick={onCancel}>Cancel</button>
</div>

{!editForm.isParent && !editForm.isChild && (
  <div style={{ marginTop: '1rem', paddingTop: '1rem',
    borderTop: '1px solid #eee' }}>
    <div style={{ fontSize: '0.85rem', fontWeight: 700,
      marginBottom: '0.5rem', color: '#555' }}>
      Split this need into smaller units
    </div>
    <div style={{ fontSize: '0.8rem', color: '#888',
      marginBottom: '0.75rem' }}>
      For high-cost needs, split into multiple units so
      several donors can each cover a portion.
    </div>
    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Number of units</label>
        <input type="number" min="2" max="20"
          placeholder="e.g. 4"
          value={splitUnits}
          onChange={e => setSplitUnits(e.target.value)}
          style={ST.inp} />
      </div>
      <div>
        <label style={ST.lbl}>Price per unit ($)</label>
        <input type="number" step="0.01"
          placeholder="e.g. 15.00"
          value={splitUnitPrice}
          onChange={e => setSplitUnitPrice(e.target.value)}
          style={ST.inp} />
      </div>
    </div>
    {splitUnits && splitUnitPrice && (
      <div style={{ fontSize: '0.85rem', color: '#2d6a4f',
        fontWeight: 600, marginBottom: '0.75rem' }}>
        {splitUnits} donors × ${splitUnitPrice}/
        {editForm.frequency} = $
        {(parseFloat(splitUnits) *
          parseFloat(splitUnitPrice)).toFixed(2)} total
      </div>
    )}
    <button
      style={{ ...ST.btnMatch, opacity:
        (!splitUnits || !splitUnitPrice) ? 0.5 : 1 }}
      disabled={!splitUnits || !splitUnitPrice}
      onClick={() => {
        if (window.confirm(
          `Split into ${splitUnits} units at $${splitUnitPrice} each? This cannot be undone.`
        )) {
          splitNeed(editForm.id, splitUnits, splitUnitPrice);
          onCancel();
        }
      }}
    >
      Split this need
    </button>
  </div>
)}
      </div>
    </>
  );
}

function NeedRow({ need, editingNeed, setEditingNeed, startEdit,
  editForm, setEditForm, saveEdit, splitNeed, splitUnits,
  setSplitUnits, splitUnitPrice, setSplitUnitPrice, deleteNeed, reopenNeedAndCancelCommitments }) {
  return (
    <div style={{ background: '#f9fafb', borderRadius: '10px',
      padding: '1rem', marginBottom: '0.75rem',
      border: '1px solid #eee' }}>
      {editingNeed === need.id ? (
        <NeedEditForm
          need={need}
          onSave={() => saveEdit(need.id)}
          onCancel={() => { setEditingNeed(null); setEditForm({}); }}
          editForm={editForm}
          setEditForm={setEditForm}
          splitNeed={splitNeed}
          splitUnits={splitUnits}
          setSplitUnits={setSplitUnits}
          splitUnitPrice={splitUnitPrice}
          setSplitUnitPrice={setSplitUnitPrice}
        />
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '0.25rem' }}>{need.itemName}</div>
            <div style={{ fontSize: '0.8rem', color: '#888', marginBottom: '0.35rem' }}>
              <span style={{ textTransform: 'capitalize', fontWeight: 600, color: need.status === 'open' ? '#065f46' : need.status === 'funded' ? '#1e40af' : need.status === 'pending_match' ? '#92400e' : '#6b7280' }}>
                {need.status === 'pending_match' ? 'Pending match' : need.status}
              </span>
              {' '}&bull;{' '}<span style={{ textTransform: 'capitalize' }}>{need.priority}</span>
              {' '}&bull; {need.frequency}
            </div>
            <div style={{ fontSize: '0.85rem', color: '#555' }}>{need.impactStatement}</div>
          </div>
          <div style={{ textAlign: 'right', minWidth: '140px', flexShrink: 0 }}>
            {need.pricePerCycle ? (
              <div style={{ fontWeight: 700, color: '#1e3a5f', fontSize: '1rem' }}>
                ${need.pricePerCycle}<span style={{ fontSize: '0.8rem', fontWeight: 400, color: '#888' }}>/{need.frequency}</span>
              </div>
            ) : (
              <div style={{ fontSize: '0.85rem', color: '#888', fontStyle: 'italic' }}>Price TBD</div>
            )}
            <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '0.2rem' }}>{need.sponsorCount || 0} sponsor{need.sponsorCount !== 1 ? 's' : ''}</div>
            <div style={{ display: 'flex', gap: '0.4rem', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
  <button
    style={{ ...ST.btnMatch, padding: '0.35rem 0.875rem', fontSize: '0.8rem' }}
    onClick={() => startEdit(need)}
  >
    Edit
  </button>
  {need.status !== 'open' && (
  <button
    style={{ ...ST.btnApprove, padding: '0.35rem 0.875rem', fontSize: '0.8rem' }}
    onClick={() => reopenNeedAndCancelCommitments(need)}
  >
    Reopen
  </button>
)}

  <button
    style={{ ...ST.btnReject, padding: '0.35rem 0.875rem', fontSize: '0.8rem' }}
    onClick={() => deleteNeed(need)}
  >
    Delete
  </button>
  
</div>
          </div>
        </div>
      )}
    </div>
  );
}
function buildDonorRecognition(donor) {
  const first = donor?.firstName || '';
  const lastInitial = donor?.lastName ? `${donor.lastName.charAt(0)}.` : '';
  const city = donor?.city || '';
  const state = donor?.state || '';

  switch (donor?.anonymityPreference) {
    case 'anonymous':
      return 'A local donor';

    case 'firstNameOnly':
      return first || 'A local donor';

    case 'firstLastInitial':
      return first ? `${first} ${lastInitial}`.trim() : 'A local donor';

    case 'firstLastInitialCity':
      return first
        ? `${first} ${lastInitial}${city ? ` from ${city}${state ? `, ${state}` : ''}` : ''}`.trim()
        : 'A local donor';

    default:
      return first ? `${first} ${lastInitial}`.trim() : 'A local donor';
  }
}

function OrgNeedAdminBlock({
  org,
  orgNeeds,
  addingNeedForOrg,
  setAddingNeedForOrg,
  adminNeedForm,
  setAdminNeedForm,
  addNeedForOrg,
  resetAdminNeedForm,
  needRowProps
}) {
  const isAdding = addingNeedForOrg === org.id;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
        <div style={{ fontSize: '0.9rem', fontWeight: 700 }}>
          Needs ({orgNeeds.length})
        </div>

        {!isAdding && (
          <button
            style={{ ...ST.btnApprove, padding: '0.4rem 0.9rem', fontSize: '0.82rem' }}
            onClick={() => setAddingNeedForOrg(org.id)}
          >
            Add need for this org
          </button>
        )}
      </div>

      {isAdding && (
        <div style={{
          background: '#f9fafb',
          border: '1px solid #eee',
          borderRadius: '10px',
          padding: '1rem',
          marginBottom: '1rem'
        }}>
          <div style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '0.75rem' }}>
  Add need for {org.orgName}
</div>

<div style={ST.fullRow}>
  <label style={ST.lbl}>Need type</label>
  <select
    value={adminNeedForm.type || 'supply'}
    onChange={e => setAdminNeedForm(prev => ({ ...prev, type: e.target.value }))}
    style={ST.inp}
  >
    <option value="supply">Supply</option>
    <option value="sponsorship">Sponsorship</option>
  </select>
</div>

          <div style={ST.grid2}>
            <div>
              <label style={ST.lbl}>Item name</label>
              <input
                value={adminNeedForm.itemName}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, itemName: e.target.value }))}
                style={ST.inp}
                placeholder="Laundry detergent"
              />
            </div>

            <div>
              <label style={ST.lbl}>Priority</label>
              <select
                value={adminNeedForm.priority}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, priority: e.target.value }))}
                style={ST.inp}
              >
                <option value="critical">Critical</option>
                <option value="core">Core</option>
                <option value="supplemental">Supplemental</option>
              </select>
            </div>
          </div>

          <div style={ST.fullRow}>
            <label style={ST.lbl}>Description</label>
            <textarea
              value={adminNeedForm.description}
              onChange={e => setAdminNeedForm(prev => ({ ...prev, description: e.target.value }))}
              style={{ ...ST.inp, minHeight: '70px', resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <div style={ST.grid2}>
            <div>
              <label style={ST.lbl}>Frequency</label>
              <select
                value={adminNeedForm.frequency}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, frequency: e.target.value }))}
                style={ST.inp}
              >
                <option value="monthly">Monthly</option>
                <option value="bi-monthly">Bi-monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="one-time">One-time</option>
              </select>
            </div>

            <div>
              <label style={ST.lbl}>Preferred delivery day</label>
              <input
                type="number"
                min="1"
                max="28"
                value={adminNeedForm.preferredDeliveryDay}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, preferredDeliveryDay: e.target.value }))}
                style={ST.inp}
              />
            </div>
          </div>

          <div style={ST.grid2}>
            <div>
              <label style={ST.lbl}>Quantity per cycle</label>
              <input
                type="number"
                value={adminNeedForm.quantityPerCycle}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, quantityPerCycle: e.target.value }))}
                style={ST.inp}
              />
            </div>

            <div>
              <label style={ST.lbl}>Impact quantity</label>
              <input
                type="number"
                value={adminNeedForm.impactQuantity}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, impactQuantity: e.target.value }))}
                style={ST.inp}
                placeholder="48"
              />
            </div>
          </div>

          <div style={ST.fullRow}>
            <label style={ST.lbl}>Impact unit</label>
            <input
              value={adminNeedForm.impactUnit}
              onChange={e => setAdminNeedForm(prev => ({ ...prev, impactUnit: e.target.value }))}
              style={ST.inp}
              placeholder="diaper changes, meals, hygiene kits"
            />
          </div>

          <div style={ST.fullRow}>
            <label style={ST.lbl}>Community Priority (CFR) — up to 3</label>
            <AdminCfrPicker
              selected={adminNeedForm.cfrCategories || []}
              onChange={val => setAdminNeedForm(prev => ({ ...prev, cfrCategories: val }))}
            />
          </div>

          <div style={ST.grid2}>
            <div>
              <label style={ST.lbl}>Base cost ($)</label>
              <input
                type="number"
                step="0.01"
                value={adminNeedForm.baseCost}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, baseCost: e.target.value }))}
                style={ST.inp}
              />
            </div>

            <div>
              <label style={ST.lbl}>Markup %</label>
              <input
                type="number"
                value={adminNeedForm.markupPct}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, markupPct: e.target.value }))}
                style={ST.inp}
              />
            </div>
          </div>

          <div style={ST.grid2}>
            <div>
              <label style={ST.lbl}>Vendor</label>
              <input
                value={adminNeedForm.vendorName}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, vendorName: e.target.value }))}
                style={ST.inp}
                placeholder="Amazon"
              />
            </div>

            <div>
              <label style={ST.lbl}>Product URL</label>
              <input
                value={adminNeedForm.vendorProductUrl}
                onChange={e => setAdminNeedForm(prev => ({ ...prev, vendorProductUrl: e.target.value }))}
                style={ST.inp}
              />
            </div>
          </div>

          <div style={ST.btnRow}>
            <button style={ST.btnApprove} onClick={() => addNeedForOrg(org)}>
              Save need
            </button>

            <button
              style={ST.btnCancel}
              onClick={() => {
                setAddingNeedForOrg(null);
                resetAdminNeedForm();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {orgNeeds.length === 0 ? (
        <div style={{ color: '#888', fontSize: '0.9rem' }}>No needs listed yet.</div>
      ) : (
        orgNeeds.map(need => (
          <NeedRow key={need.id} need={need} {...needRowProps} />
        ))
      )}
    </>
  );
}

function AdminDashboard() {
  const navigate = useNavigate();
  const [pendingOrgs, setPendingOrgs] = useState([]);
  const [activeOrgs, setActiveOrgs] = useState([]);
  const [donors, setDonors] = useState([]);
  const [unmatchedNeeds, setUnmatchedNeeds] = useState([]);
  const [allNeeds, setAllNeeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('pending');
  const [matchingNeed, setMatchingNeed] = useState(null);
  const [matchForm, setMatchForm] = useState({});
  const [editingNeed, setEditingNeed] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [editingOrg, setEditingOrg] = useState(null);
  const [orgEditForm, setOrgEditForm] = useState({});
  const [waitlist, setWaitlist] = useState([]);
  const [splitUnits, setSplitUnits] = useState('');
  const [splitUnitPrice, setSplitUnitPrice] = useState('');
  const [billingDue, setBillingDue] = useState([]);
  const [selectedDonors, setSelectedDonors] = useState(new Set());
  const [billingResults, setBillingResults] = useState({});
  const [billingRunning, setBillingRunning] = useState(false);
  const [ordersNeeded, setOrdersNeeded] = useState([]);
  const [orderedItems, setOrderedItems] = useState([]);
  const [markedOrdered, setMarkedOrdered] = useState(new Set());
  const [orderingItems, setOrderingItems] = useState(false);
  const [ordersGroupBy, setOrdersGroupBy] = useState('org');
  const [trackingForm, setTrackingForm] = useState({});
  const [savingTracking, setSavingTracking] = useState({});
  const [sponsorshipCommitments, setSponsorshipCommitments] = useState([]);
  const [inviteForm, setInviteForm] = useState({
  orgName: '',
  contactName: '',
  contactTitle: '',
  email: '',
  phone: '',
  website: '',
  missionStatement: '',
  populationsServed: '',
  orgType: 'other',
  cfrCategories: [],
  ein: '',
  address: '',
  city: 'Springfield',
  state: 'MO',
  zip: '',
  shippingSameAsMailing: true,
  shippingAddress: '',
  shippingCity: 'Springfield',
  shippingState: 'MO',
  shippingZip: '',
  shippingContactName: '',
  shippingInstructions: ''
});
const [invitedOrgs, setInvitedOrgs] = useState([]);
const [addingNeedForOrg, setAddingNeedForOrg] = useState(null);
const [adminNeedForm, setAdminNeedForm] = useState({
  type: 'supply',
  itemName: '',
  description: '',
  priority: 'critical',
  frequency: 'monthly',
  preferredDeliveryDay: 1,
  quantityPerCycle: 1,
  impactQuantity: '',
  impactUnit: '',
  baseCost: '',
  markupPct: 5,
  cfrCategories: [],
  vendorName: '',
  vendorProductUrl: ''
});

const [creatingInvite, setCreatingInvite] = useState(false);
const [lastInviteResult, setLastInviteResult] = useState(null);


  useEffect(() => { fetchData(); }, []);

 
async function fetchData() {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    const [
      pendingSnap,
      invitedSnap,
      activeSnap,
      donorsSnap,
      unmatchedSnap,
      allNeedsSnap,
      waitlistSnap,
      billingSnap,
      ordersSnap,
      orderedSnap,
      subsSnap,
      sponsorshipSnap
    ] = await Promise.all([
      getDocs(query(collection(db, 'organizations'), where('status', '==', 'pending'))),
      getDocs(query(collection(db, 'organizations'), where('status', '==', 'invited'))),
      getDocs(query(collection(db, 'organizations'), where('status', '==', 'active'))),
      getDocs(query(collection(db, 'donors'))),
      getDocs(query(collection(db, 'needs'), where('status', '==', 'pending_match'))),
      getDocs(query(collection(db, 'needs'))),
      getDocs(query(collection(db, 'waitlist'))),
      getDocs(query(
        collection(db, 'subscriptions'),
        where('status', '==', 'active'),
        where('nextBillingDate', '<', Timestamp.fromDate(dayAfterTomorrow))
      )),
      getDocs(query(
        collection(db, 'subscriptions'),
        where('orderStatus', '==', 'needed')
      )),
      getDocs(query(
  collection(db, 'orders'),
  where('status', 'in', ['ordered', 'shipped'])
)),

      getDocs(collection(db, 'subscriptions')),
      getDocs(collection(db, 'sponsorshipCommitments'))
    ]);

    setPendingOrgs(pendingSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setInvitedOrgs(invitedSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setActiveOrgs(activeSnap.docs.map(d => ({ id: d.id, ...d.data() })));

    const allSubs = subsSnap.docs.map(d => d.data());
    const activeSubsByDonor = {};

    allSubs.forEach(sub => {
      if (sub.status === 'active') {
        activeSubsByDonor[sub.donorId] =
          (activeSubsByDonor[sub.donorId] || 0) + 1;
      }
    });

    setDonors(donorsSnap.docs.map(d => ({
      id: d.id,
      ...d.data(),
      activeSubCount: activeSubsByDonor[d.id] || 0
    })));

    setUnmatchedNeeds(unmatchedSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setAllNeeds(allNeedsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setWaitlist(waitlistSnap.docs.map(d => ({ id: d.id, ...d.data() })));

    const billingMap = {};
    billingSnap.docs.forEach(d => {
      const data = { id: d.id, ...d.data() };
      if (!billingMap[data.donorId]) {
        billingMap[data.donorId] = {
          donorId: data.donorId,
          donorName: data.donorName,
          donorFirstName: data.donorFirstName,
          subs: []
        };
      }
      billingMap[data.donorId].subs.push(data);
    });

    setBillingDue(Object.values(billingMap));
    setOrdersNeeded(ordersSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setOrderedItems(orderedSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    setSponsorshipCommitments(
    sponsorshipSnap.docs.map(d => ({ id: d.id, ...d.data() })));
  } catch (err) {
    console.error('Error fetching data:', err);
  } finally {
    setLoading(false);
  }
}

  async function approveOrg(orgId) {
    try {
      await updateDoc(doc(db, 'organizations', orgId), { status: 'active', approvedAt: serverTimestamp() });
      await fetchData();
      alert('Organization approved successfully.');
    } catch (err) { alert('Error approving organization.'); }
  }

  async function rejectOrg(orgId) {
    if (!window.confirm('Are you sure you want to reject this application?')) return;
    try {
      await updateDoc(doc(db, 'organizations', orgId), { status: 'rejected' });
      await fetchData();
    } catch (err) { console.error(err); }
  }

  async function matchNeed(needId, formData) {
  try {
    const basePrice = parseFloat(formData.basePrice);
    const markupPct = parseFloat(formData.markupPct) || 5;
    const donorPrice = Math.ceil(
      basePrice * (1 + markupPct / 100)
    );

    // If split values provided, split instead of single match
    if (splitUnits && splitUnitPrice && parseInt(splitUnits) >= 2) {
      await splitNeed(
        needId,
        splitUnits,
        splitUnitPrice,
        formData.vendorName,
        formData.vendorProductUrl
      );
      setMatchingNeed(null);
      setMatchForm({});
      setSplitUnits('');
      setSplitUnitPrice('');
      return;
    }

    await updateDoc(doc(db, 'needs', needId), {
      status: 'open',
      pricePerCycle: donorPrice,
      baseCost: basePrice,
      markupPct,
      vendorName: formData.vendorName || 'Amazon',
      vendorProductUrl: formData.vendorProductUrl || '',
      priceVerifiedDate: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    setMatchingNeed(null);
    setMatchForm({});
    setSplitUnits('');
    setSplitUnitPrice('');
    await fetchData();
    alert('Need is now live to donors.');
  } catch (err) {
    console.error(err);
    alert('Error saving catalog match.');
  }
}

  function startEdit(need) {
    setEditingNeed(need.id);
    setEditForm({
  id: need.id,
  type: need.type || 'supply',
  itemName: need.itemName || '',
  description: need.description || '',
  priority: need.priority || 'critical',
  frequency: need.frequency || 'monthly',
  preferredDeliveryDay: need.preferredDeliveryDay || 1,
  quantityPerCycle: need.quantityPerCycle || '',
  impactQuantity: need.impactQuantity || '',
  impactUnit: need.impactUnit || '',
  pricePerCycle: need.pricePerCycle || '',
  baseCost: need.baseCost || '',
  markupPct: need.markupPct || 5,
  vendorName: need.vendorName || '',
  vendorProductUrl: need.vendorProductUrl || '',
  status: need.status || 'open',
  cfrCategories: need.cfrCategories || [],
  isParent: need.isParent || false,
  isChild: need.isChild || false
});
  }

  async function saveEdit(needId) {
  try {
    const impactQuantity = parseInt(editForm.impactQuantity);
    const baseCost = parseFloat(editForm.baseCost) || 0;
    const markupPct = parseFloat(editForm.markupPct) || 5;
    const donorPrice = Math.ceil(baseCost * (1 + markupPct / 100));

    await updateDoc(doc(db, 'needs', needId), {
      type: editForm.type || 'supply',
      itemName: editForm.itemName,
      description: editForm.description,
      priority: editForm.priority,
      frequency: editForm.frequency,
      preferredDeliveryDay: parseInt(editForm.preferredDeliveryDay || 1),
      quantityPerCycle: parseInt(editForm.quantityPerCycle),
      impactQuantity,
      impactUnit: editForm.impactUnit,
      impactStatement: `One delivery provides ${impactQuantity} ${editForm.impactUnit}`,
      pricePerCycle: donorPrice,
      baseCost,
      markupPct,
      vendorName: editForm.vendorName,
      vendorProductUrl: editForm.vendorProductUrl,
      status: editForm.status,
      cfrCategories: editForm.cfrCategories || [],
      updatedAt: serverTimestamp()
    });

    setEditingNeed(null);
    setEditForm({});
    await fetchData();
    alert('Need updated successfully.');
  } catch (err) {
    alert('Error saving changes.');
  }
}

  async function splitNeed(needId, numUnits, unitPrice,
  vendorName, vendorProductUrl) {
  try {
    const need = allNeeds.find(n => n.id === needId) ||
      unmatchedNeeds.find(n => n.id === needId);
    if (!need) return;

    const units = parseInt(numUnits);
    const price = parseFloat(unitPrice);

    await updateDoc(doc(db, 'needs', needId), {
      isParent: true,
      totalUnits: units,
      unitPrice: price,
      status: 'split',
      vendorName: vendorName || need.vendorName || 'Amazon',
      vendorProductUrl: vendorProductUrl ||
        need.vendorProductUrl || '',
      updatedAt: serverTimestamp()
    });

    for (let i = 1; i <= units; i++) {
      await addDoc(collection(db, 'needs'), {
        orgId: need.orgId,
        orgName: need.orgName,
        type: 'supply',
        itemName: `${need.itemName} (unit ${i} of ${units})`,
        description: need.description,
        priority: need.priority,
        frequency: need.frequency,
        quantityPerCycle: Math.floor(
          (need.quantityPerCycle || 1) / units
        ),
        pricePerCycle: Math.ceil(price),
baseCost: Math.ceil(price),
markupPct: 0,
        impactQuantity: Math.floor(
          (need.impactQuantity || 1) / units
        ),
        impactUnit: need.impactUnit,
        impactStatement: `One delivery provides ${Math.floor((need.impactQuantity || 1) / units)} ${need.impactUnit}`,
        vendorProductUrl: vendorProductUrl ||
          need.vendorProductUrl || '',
        vendorName: vendorName || need.vendorName || 'Amazon',
        status: 'open',
        sponsorCount: 0,
        isChild: true,
        parentNeedId: needId,
        unitNumber: i,
        totalUnits: units,
        community: need.community || 'springfield',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    }

    await fetchData();
    alert(`Need split into ${units} units of $${price} each. Child needs are now live to donors.`);
  } catch (err) {
    console.error('Error splitting need:', err);
    alert('Error splitting need.');
  }
}



  async function saveOrgEdit(orgId) {
    try {
      await updateDoc(doc(db, 'organizations', orgId), {
        orgName: orgEditForm.orgName, contactName: orgEditForm.contactName,
        contactTitle: orgEditForm.contactTitle, phone: orgEditForm.phone,
        website: orgEditForm.website, missionStatement: orgEditForm.missionStatement,
        populationsServed: orgEditForm.populationsServed,
        address: orgEditForm.address, city: orgEditForm.city,
        state: orgEditForm.state, zip: orgEditForm.zip,
        shippingAddress: orgEditForm.shippingAddress,
        shippingCity: orgEditForm.shippingCity,
        shippingState: orgEditForm.shippingState,
        shippingZip: orgEditForm.shippingZip,
        shippingContactName: orgEditForm.shippingContactName,
        shippingInstructions: orgEditForm.shippingInstructions,
        cfrCategories: orgEditForm.cfrCategories || [],
        status: orgEditForm.status, updatedAt: serverTimestamp()
      });
      setEditingOrg(null); setOrgEditForm({});
      await fetchData();
      alert('Organization updated successfully.');
    } catch (err) { alert('Error saving changes.'); }
  }

  async function handleSignOut() {
    await signOut(auth);
    navigate('/admin');
  }

  const tabs = [
  { key: 'invite', label: 'Invite Org' },
  { key: 'invited', label: `Invited orgs (${invitedOrgs.length})` },
  { key: 'pending', label: `Pending orgs (${pendingOrgs.length})` },
  { key: 'active', label: `Active orgs (${activeOrgs.length})` },
  { key: 'needs', label: `Needs to match (${unmatchedNeeds.length})` },
  { key: 'allneeds', label: `All needs (${allNeeds.length})` },
  { key: 'donors', label: `Donors (${donors.length})` },
  { key: 'waitlist', label: `Waitlist (${waitlist.length})` },
  { key: 'billing', label: `Billing due (${billingDue.length})` },
  { key: 'sponsorships', label: `Adopted Sponsorships (${sponsorshipCommitments.length})` },
  { key: 'orders', label: `Orders needed (${ordersNeeded.length})` },
  { key: 'ordered', label: `Ordered/Shipped (${orderedItems.length})` },
  { key: 'tools', label: 'Admin Tools' },
  { key: 'copyNeeds', label: 'Copy Needs' },
  { key: 'importWishlist', label: 'Import Wishlist' }
];




async function runBilling() {
  
  
  if (selectedDonors.size === 0) return;
  if (!window.confirm(`Run billing for ${selectedDonors.size} donor(s)?`)) return;

  try {
    setBillingRunning(true);
    const functions = getFunctions();
    const runBillingFn = httpsCallable(functions, 'runBilling');
    const result = await runBillingFn({ donorIds: Array.from(selectedDonors) });

    setBillingResults(result.data.results);
    setSelectedDonors(new Set());

    await fetchData();

    const anySuccess = Object.values(result.data.results || {}).some(r => r?.success);
    if (anySuccess) {
      setActiveTab('orders');
    }
  } catch (err) {
    console.error('Billing error:', err);
    alert('Error running billing: ' + err.message);
  } finally {
    setBillingRunning(false);
  }
}


async function sendPaymentReminder(donorId, donorEmail, donorFirstName) {
  try {
    const functions = getFunctions();
    const sendReminder = httpsCallable(functions, 'sendPaymentReminder');
    await sendReminder({ donorId, donorEmail, donorFirstName });
    alert(`Reminder sent to ${donorEmail}`);
  } catch (err) {
    alert('Error sending reminder: ' + err.message);
  }
}

async function markAsOrdered(subs) {
  try {
    setOrderingItems(true);
    const batch = writeBatch(db);

    for (const sub of subs) {
      const orgDoc = await getDocs(query(
        collection(db, 'organizations'),
        where('__name__', '==', sub.orgId)
      ));
      const org = orgDoc.docs[0]?.data() || {};

      const donor = donors.find(d => d.id === sub.donorId) || {};

      const donorRecognition = {
        preference: donor.anonymityPreference || 'firstLastInitialCity',
        displayText: buildDonorRecognition(donor)
      };

      const orderRef = doc(collection(db, 'orders'));
      batch.set(orderRef, {
  subscriptionId: sub.id,
  needId: sub.needId,
  donorId: sub.donorId,

  networkId: sub.networkId || null,
  networkName: sub.networkName || null,

  donorRecognition,
  orgId: sub.orgId,
  orgName: sub.orgName,
  itemName: sub.itemName,
        quantityPerCycle: sub.quantityPerCycle || 1,
        frequency: sub.frequency || '',
        vendorProductUrl: sub.vendorProductUrl || '',
        vendorName: sub.vendorName || '',
        impactStatement: sub.impactStatement || '',
        impactQuantity: sub.impactQuantity || 0,
        impactUnit: sub.impactUnit || '',
        shippingAddress: org.shippingAddress || org.address || '',
        shippingCity: org.shippingCity || org.city || '',
        shippingState: org.shippingState || org.state || '',
        shippingZip: org.shippingZip || org.zip || '',
        shippingContactName: org.shippingContactName || org.contactName || '',
        shippingInstructions: org.shippingInstructions || '',
        billedDate: sub.lastBilledDate || null,
        orderDueDate: sub.orderDueDate || null,
        targetDeliveryDate: sub.deliveryDueDate || null,
        orderedAt: serverTimestamp(),
        status: 'ordered',
        lastPaymentId: sub.lastPaymentId || null
      });

      batch.update(doc(db, 'subscriptions', sub.id), {
        orderStatus: 'ordered',
        orderedAt: serverTimestamp()
      });
    }

    await batch.commit();
    setMarkedOrdered(new Set());
    await fetchData();
    alert(`${subs.length} order(s) recorded.`);
  } catch (err) {
    console.error('Error marking as ordered:', err);
    alert('Error: ' + err.message);
  } finally {
    setOrderingItems(false);
  }
}



async function markAsDelivered(orderId, subscriptionId, needId) {
  try {
    const batch = writeBatch(db);

    const subRef = doc(db, 'subscriptions', subscriptionId);
    const orderRef = doc(db, 'orders', orderId);

    batch.update(orderRef, {
      status: 'delivered',
      deliveredAt: serverTimestamp()
    });

    batch.update(subRef, {
      orderStatus: 'delivered',
      deliveredAt: serverTimestamp()
    });

    await batch.commit();
    await fetchData();
  } catch (err) {
    console.error('Error marking as delivered:', err);
    alert('Error: ' + err.message);
  }
}


async function saveTracking(orderId, subscriptionId) {
  const form = trackingForm[orderId] || {};
  const carrier = (form.carrier || '').trim();
  const trackingNumber = (form.trackingNumber || '').trim();
  const trackingUrl = (form.trackingUrl || '').trim();

  if (!carrier || !trackingNumber) {
    alert('Carrier and tracking number are required.');
    return;
  }

  try {
    setSavingTracking(prev => ({ ...prev, [orderId]: true }));

    const batch = writeBatch(db);

    batch.update(doc(db, 'orders', orderId), {
      carrier,
      trackingNumber,
      trackingUrl,
      status: 'shipped',
      shippedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });

    batch.update(doc(db, 'subscriptions', subscriptionId), {
      orderStatus: 'shipped',
      carrier,
      trackingNumber,
      trackingUrl,
      shippedAt: serverTimestamp()
    });

    await batch.commit();

    setTrackingForm(prev => {
      const next = { ...prev };
      delete next[orderId];
      return next;
    });

    await fetchData();
    alert('Tracking saved.');
  } catch (err) {
    console.error('Error saving tracking:', err);
    alert('Error saving tracking: ' + err.message);
  } finally {
    setSavingTracking(prev => ({ ...prev, [orderId]: false }));
  }
}

async function createOrgInvite() {
  if (!inviteForm.orgName.trim()) {
    alert('Organization name is required.');
    return;
  }

  if (!inviteForm.email.trim()) {
    alert('Contact email is required.');
    return;
  }

  try {
    setCreatingInvite(true);
    setLastInviteResult(null);

    const functions = getFunctions();
    const createOrgInviteFn = httpsCallable(functions, 'createOrgInvite');

    const result = await createOrgInviteFn(inviteForm);

    setLastInviteResult(result.data);

    alert('Invite created and email sent.');

    setInviteForm({
      orgName: '',
      contactName: '',
      contactTitle: '',
      email: '',
      phone: '',
      website: '',
      missionStatement: '',
      populationsServed: '',
      orgType: 'other',
      cfrCategories: [],
      ein: '',
      address: '',
      city: 'Springfield',
      state: 'MO',
      zip: '',
      shippingSameAsMailing: true,
      shippingAddress: '',
      shippingCity: 'Springfield',
      shippingState: 'MO',
      shippingZip: '',
      shippingContactName: '',
      shippingInstructions: ''
    });

    await fetchData();
  } catch (err) {
    console.error('Error creating org invite:', err);
    alert('Error creating org invite: ' + err.message);
  } finally {
    setCreatingInvite(false);
  }
}
function resetAdminNeedForm() {
  setAdminNeedForm({
    type: 'supply',
    itemName: '',
    description: '',
    priority: 'critical',
    frequency: 'monthly',
    preferredDeliveryDay: 1,
    quantityPerCycle: 1,
    impactQuantity: '',
    impactUnit: '',
    baseCost: '',
    markupPct: 5,
    cfrCategories: [],
    vendorName: '',
    vendorProductUrl: ''
  });
}

async function addNeedForOrg(org) {
  if (!adminNeedForm.itemName.trim()) {
    alert('Item name is required.');
    return;
  }

  const impactQuantity = Number(adminNeedForm.impactQuantity || 0);
  const baseCost = Number(adminNeedForm.baseCost || 0);
  const markupPct = Number(adminNeedForm.markupPct || 5);
  const pricePerCycle = baseCost > 0
    ? Math.ceil(baseCost * (1 + markupPct / 100))
    : null;

    const needType = adminNeedForm.type || 'supply';

  try {
    await addDoc(collection(db, 'needs'), {
      orgId: org.id,
      orgName: org.orgName || '',
      type: needType,
      itemName: adminNeedForm.itemName,
      description: adminNeedForm.description,
      priority: adminNeedForm.priority,
      frequency: adminNeedForm.frequency,
      preferredDeliveryDay: Number(adminNeedForm.preferredDeliveryDay || 1),
      quantityPerCycle: Number(adminNeedForm.quantityPerCycle || 1),
      impactQuantity,
      impactUnit: adminNeedForm.impactUnit,
      impactStatement: impactQuantity && adminNeedForm.impactUnit
        ? `One delivery provides ${impactQuantity} ${adminNeedForm.impactUnit}`
        : '',
      baseCost: baseCost || null,
markupPct,
pricePerCycle,
status: needType === 'sponsorship'
  ? 'open'
  : pricePerCycle
    ? 'open'
    : 'pending_match',
vendorName: adminNeedForm.vendorName || '',
vendorProductUrl: adminNeedForm.vendorProductUrl || '',
      cfrCategories: adminNeedForm.cfrCategories || [],
      sponsorCount: 0,
      createdByAdmin: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      community: org.community || 'springfield'
    });

    setAddingNeedForOrg(null);
    resetAdminNeedForm();
    await fetchData();

    alert(pricePerCycle
      ? 'Need added and opened to donors.'
      : 'Need added and sent to Needs to Match.'
    );
  } catch (err) {
    console.error('Error adding need:', err);
    alert('Error adding need: ' + err.message);
  }
}
async function setNeedStatus(need, newStatus) {
  const confirmed = window.confirm(
  `Change status for this need?\n\n${need.itemName}\n\n${need.status} → ${newStatus}\n\nThis only changes the need status. It does NOT cancel subscriptions, delete sponsorship commitments, remove billing, or alter donor history.`
);

  if (!confirmed) return;

  try {
    await updateDoc(doc(db, 'needs', need.id), {
      status: newStatus,
      updatedAt: serverTimestamp()
    });

    await fetchData();
    alert(`Need status changed to ${newStatus}.`);
  } catch (err) {
    console.error('Error changing need status:', err);
    alert('Error changing need status: ' + err.message);
  }
}

async function reopenNeedAndCancelCommitments(need) {
  const confirmed = window.confirm(
    `Reopen this need?\n\n${need.itemName}\n\nThis will cancel active subscription/sponsorship records for this need, preserve history, and make the need available again.`
  );

  if (!confirmed) return;

  try {
    const functions = getFunctions();
    const reopenFn = httpsCallable(functions, 'reopenNeedAndCancelCommitments');

    const result = await reopenFn({
      needId: need.id,
      reason: 'admin_reopened_need'
    });

    await fetchData();

    alert(
      `Need reopened.\n\nCanceled subscriptions: ${result.data.canceledSubscriptions || 0}\nCanceled sponsorship commitments: ${result.data.canceledSponsorshipCommitments || 0}`
    );
  } catch (err) {
    console.error('Error reopening need:', err);
    alert('Error reopening need: ' + err.message);
  }
}

async function deleteNeed(need) {
  const sponsorCount = Number(need.sponsorCount || 0);

  if (sponsorCount > 0 || need.status === 'funded') {
    alert('Do not delete sponsored/funded needs. Discontinue or replace them instead.');
    return;
  }

  const confirmed = window.confirm(
    `Delete this need?\n\n${need.itemName}\n\nThis cannot be undone.`
  );

  if (!confirmed) return;

  try {
    await deleteDoc(doc(db, 'needs', need.id));
    await fetchData();
    alert('Need deleted.');
  } catch (err) {
    console.error('Error deleting need:', err);
    alert('Error deleting need: ' + err.message);
  }
}

  const needRowProps = { 
  editingNeed, setEditingNeed, startEdit, editForm, setEditForm, 
  saveEdit, splitNeed, splitUnits, setSplitUnits, 
  splitUnitPrice, setSplitUnitPrice, deleteNeed, reopenNeedAndCancelCommitments
};

  return (
    <div style={ST.page}>
      <header style={ST.header}>
        <div style={ST.logo}>somebody.gives - Admin</div>
        <button onClick={handleSignOut} style={ST.btnSignout}>Sign out</button>
      </header>

      <main style={ST.main}>

        <div style={ST.statsGrid}>
          <div style={ST.statCard}><div style={ST.statNum}>{pendingOrgs.length}</div><div style={ST.statLabel}>Pending org approvals</div></div>
          <div style={ST.statCard}><div style={ST.statNum}>{unmatchedNeeds.length}</div><div style={ST.statLabel}>Needs to match</div></div>
          <div style={ST.statCard}><div style={ST.statNum}>{activeOrgs.length}</div><div style={ST.statLabel}>Active orgs</div></div>
          <div style={ST.statCard}><div style={ST.statNum}>{donors.length}</div><div style={ST.statLabel}>Active donors</div></div>
        </div>

        <div style={ST.tabs}>
          {tabs.map(tab => (
            <button key={tab.key} style={{ ...ST.tab, ...(activeTab === tab.key ? ST.tabActive : {}) }} onClick={() => setActiveTab(tab.key)}>
              {tab.label}
            </button>
          ))}
        </div>

        {loading && <div style={ST.empty}>Loading...</div>}

        {/* Pending orgs */}
        {!loading && activeTab === 'pending' && (
          <>
            {pendingOrgs.length === 0 && <div style={ST.empty}>No pending applications.</div>}
            {pendingOrgs.map(org => (
              <div key={org.id} style={ST.card}>
                <div style={ST.orgName}>{org.orgName}</div>
                <div style={ST.orgMeta}>{org.orgType} &bull; Applied {org.createdAt?.toDate?.()?.toLocaleDateString() || 'recently'}</div>
                <div style={ST.orgDetail}><strong>Contact:</strong> {org.contactName}{org.contactTitle ? `, ${org.contactTitle}` : ''}</div>
                <div style={ST.orgDetail}><strong>Email:</strong> {org.email} &bull; <strong>Phone:</strong> {org.phone}</div>
                <div style={ST.orgDetail}><strong>Address:</strong> {org.address}, {org.city}, {org.state} {org.zip}</div>
                <div style={ST.orgDetail}><strong>Shipping:</strong> {org.shippingSameAsMailing ? 'Same as mailing' : `${org.shippingAddress}, ${org.shippingCity}, ${org.shippingState} ${org.shippingZip}`}</div>
                <div style={ST.orgDetail}><strong>EIN:</strong> {org.ein}{org.website && <span> - {org.website}</span>}</div>
                <div style={ST.orgDetail}><strong>Mission:</strong> {org.missionStatement}</div>
                <div style={ST.orgDetail}><strong>Serves:</strong> {org.populationsServed}</div>
                <div style={ST.btnRow}>
                  <button style={ST.btnApprove} onClick={() => approveOrg(org.id)}>Approve organization</button>
                  <button style={ST.btnReject} onClick={() => rejectOrg(org.id)}>Reject</button>
                </div>
              </div>
            ))}
          </>
        )}

{/* Invited orgs */}
{!loading && activeTab === 'invited' && (
  <>
    {invitedOrgs.length === 0 && (
      <div style={ST.empty}>No invited organizations waiting to claim account.</div>
    )}

    {invitedOrgs.map(org => {
      const orgNeeds = allNeeds.filter(n => n.orgId === org.id);
      const isExpanded = expandedOrg === org.id;

      return (
        <div key={org.id} style={ST.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={ST.orgName}>{org.orgName}</div>
              <div style={ST.orgMeta}>
                Invited · {org.email} · {org.city}, {org.state}
              </div>
              <div style={ST.orgDetail}>
                <strong>Contact:</strong> {org.contactName || '—'}
              </div>

              {org.inviteCode && (
                <div style={ST.orgDetail}>
                  <strong>Invite:</strong>{' '}
                  <span style={{ wordBreak: 'break-all' }}>
                    https://somebodygives.com/org/invite/{org.inviteCode}
                  </span>
                </div>
              )}

              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
                <span style={{ ...ST.badge, background: '#fef3c7', color: '#92400e' }}>
                  Invited
                </span>
                <span style={{ ...ST.badge, background: '#e0f2fe', color: '#075985' }}>
                  {orgNeeds.length} preloaded need{orgNeeds.length !== 1 ? 's' : ''}
                </span>
              </div>
            </div>

            <button
              style={{ ...ST.btnMatch, whiteSpace: 'nowrap' }}
              onClick={() => setExpandedOrg(isExpanded ? null : org.id)}
            >
              {isExpanded ? 'Hide' : 'View details'}
            </button>
          </div>

          {isExpanded && (
            <div style={{ marginTop: '1.25rem', borderTop: '1px solid #eee', paddingTop: '1.25rem' }}>
              <OrgNeedAdminBlock
                org={org}
                orgNeeds={orgNeeds}
                addingNeedForOrg={addingNeedForOrg}
                setAddingNeedForOrg={setAddingNeedForOrg}
                adminNeedForm={adminNeedForm}
                setAdminNeedForm={setAdminNeedForm}
                addNeedForOrg={addNeedForOrg}
                resetAdminNeedForm={resetAdminNeedForm}
                needRowProps={needRowProps}
              />
            </div>
          )}
        </div>
      );
    })}
  </>
)}

        {/* Needs to match */}
        {!loading && activeTab === 'needs' && (
          <>
            {unmatchedNeeds.length === 0 && <div style={ST.empty}>No needs waiting for catalog match.</div>}
            {unmatchedNeeds.map(need => (
              <div key={need.id} style={ST.card}>
                <div style={ST.orgName}>{need.itemName}</div>
                <div style={ST.orgMeta}>
  {need.orgName} &bull; <span style={{ textTransform: 'capitalize' }}>{need.type || 'supply'}</span> &bull; <span style={{ textTransform: 'capitalize' }}>{need.priority}</span> &bull; {need.frequency} &bull; qty: {need.quantityPerCycle}
</div>
                <div style={ST.orgDetail}><strong>Description:</strong> {need.description}</div>
                <div style={ST.orgDetail}><strong>Impact:</strong> {need.impactStatement}</div>
                {need.vendorSuggestionUrl && <div style={ST.orgDetail}><strong>Org suggested:</strong> {need.vendorSuggestionUrl}</div>}
                {matchingNeed === need.id ? (
                  <div style={{ marginTop: '1rem', background: '#f9fafb', padding: '1.25rem', borderRadius: '10px', border: '1px solid #eee' }}>
                    <div style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '1rem' }}>Set catalog details</div>
                    <div style={ST.grid2}>
                      <div><label style={ST.lbl}>Your cost ($)</label><input type="number" step="0.01" placeholder="e.g. 11.99" value={matchForm.basePrice || ''} onChange={e => setMatchForm(prev => ({ ...prev, basePrice: e.target.value }))} style={ST.inp} /></div>
                      <div><label style={ST.lbl}>Markup % (default 5%)</label><input type="number" placeholder="5" value={matchForm.markupPct || ''} onChange={e => setMatchForm(prev => ({ ...prev, markupPct: e.target.value }))} style={ST.inp} /></div>
                    </div>
                    {matchForm.basePrice && (
  <div style={ST.donorPrice}>Donor price: ${(parseFloat(matchForm.basePrice) * (1 + (parseFloat(matchForm.markupPct) || 5) / 100)).toFixed(2)}/{need.frequency}</div>
)}

{/* Split option during matching */}
<div style={{ marginBottom: '0.75rem', padding: '0.75rem',
  background: '#f0f4ff', borderRadius: '8px',
  border: '1px solid #dde3ff' }}>
  <div style={{ fontSize: '0.8rem', fontWeight: 700,
    marginBottom: '0.5rem', color: '#1e3a5f' }}>
    Split this need? (optional)
  </div>
  <div style={{ fontSize: '0.78rem', color: '#666',
    marginBottom: '0.5rem' }}>
    For high-cost needs, split into units so multiple donors
    can each cover a portion.
  </div>
  <div style={ST.grid2}>
    <div>
      <label style={ST.lbl}>Number of units</label>
      <input type="number" min="2" max="20"
        placeholder="e.g. 4 (or leave blank)"
        value={splitUnits}
        onChange={e => setSplitUnits(e.target.value)}
        style={ST.inp} />
    </div>
    <div>
      <label style={ST.lbl}>Price per unit ($)</label>
      <input type="number" step="0.01"
        placeholder="e.g. 15.00 (or leave blank)"
        value={splitUnitPrice}
        onChange={e => setSplitUnitPrice(e.target.value)}
        style={ST.inp} />
    </div>
  </div>
  {splitUnits && splitUnitPrice && (
  <div style={{ fontSize: '0.82rem', color: '#2d6a4f',
    fontWeight: 600, lineHeight: 1.6 }}>
    {splitUnits} donors × ${splitUnitPrice}/
    {need.frequency} = $
    {(parseFloat(splitUnits) *
      parseFloat(splitUnitPrice)).toFixed(2)} total
    <br />
    <span style={{ color: '#555', fontWeight: 400 }}>
      Impact per unit: "One delivery provides{' '}
      {Math.floor((need.impactQuantity || 1) /
        parseInt(splitUnits))}{' '}
      {need.impactUnit}" per donor
    </span>
  </div>
)}

</div>

                    <div style={ST.fullRow}><label style={ST.lbl}>Vendor name</label><input placeholder="Amazon" value={matchForm.vendorName || ''} onChange={e => setMatchForm(prev => ({ ...prev, vendorName: e.target.value }))} style={ST.inp} /></div>
                    <div style={ST.fullRow}><label style={ST.lbl}>Product URL</label><input placeholder="https://amazon.com/..." value={matchForm.vendorProductUrl || ''} onChange={e => setMatchForm(prev => ({ ...prev, vendorProductUrl: e.target.value }))} style={ST.inp} /></div>
                    <div style={ST.btnRow}>
                      <button style={{ ...ST.btnMatch, opacity: !matchForm.basePrice ? 0.5 : 1 }} onClick={() => matchNeed(need.id, matchForm)} disabled={!matchForm.basePrice}>Push live to donors</button>
                      <button style={ST.btnCancel} onClick={() => { setMatchingNeed(null); setMatchForm({}); }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div style={ST.btnRow}>
                    
<button
  style={ST.btnMatch}
  onClick={() => {
    setMatchingNeed(need.id);
    setMatchForm({
      itemName: need.itemName || '',
      description: need.description || '',
      frequency: need.frequency || 'monthly',
      quantityPerCycle: need.quantityPerCycle || 1,
      impactQuantity: need.impactQuantity || '',
      impactUnit: need.impactUnit || '',
      impactStatement: need.impactStatement || '',
      basePrice: need.baseCost || need.estimatedCost || '',
      markupPct: need.markupPct || 5,
      vendorName: need.vendorName || 'Amazon',
      vendorProductUrl:
        need.vendorProductUrl ||
        need.vendorSuggestionUrl ||
        need.productUrl ||
        ''
    });
  }}
>
  Match catalog item
</button>


                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* All needs */}
        {!loading && activeTab === 'allneeds' && (
          <>
            {allNeeds.length === 0 && <div style={ST.empty}>No needs yet.</div>}
            {allNeeds.sort((a, b) => (a.orgName || '').localeCompare(b.orgName || '')).map(need => (
              <div key={need.id} style={ST.card}>
                {editingNeed === need.id ? (
                  <NeedEditForm
  need={need}
  onSave={() => saveEdit(need.id)}
  onCancel={() => { setEditingNeed(null); setEditForm({}); }}
  editForm={editForm}
  setEditForm={setEditForm}
  splitNeed={splitNeed}
  splitUnits={splitUnits}
  setSplitUnits={setSplitUnits}
  splitUnitPrice={splitUnitPrice}
  setSplitUnitPrice={setSplitUnitPrice}
/>
                ) : (
                  <>
                    <div style={ST.orgName}>{need.itemName}</div>
                    <div style={ST.orgMeta}>{need.orgName} &bull; <span style={{ textTransform: 'capitalize' }}>{need.priority}</span> &bull; {need.frequency} &bull; qty: {need.quantityPerCycle}</div>
                    <div style={ST.orgDetail}><strong>Impact:</strong> {need.impactStatement}</div>
                    <div style={ST.orgDetail}><strong>Status:</strong> <span style={{ textTransform: 'capitalize', color: need.status === 'open' ? '#065f46' : need.status === 'funded' ? '#1e40af' : need.status === 'pending_match' ? '#92400e' : '#6b7280' }}>{need.status === 'pending_match' ? 'Pending match' : need.status}</span></div>
                    {need.pricePerCycle && <div style={ST.orgDetail}><strong>Donor price:</strong> ${need.pricePerCycle}/{need.frequency}{need.baseCost && <span style={{ color: '#888', fontSize: '0.85rem' }}> (base: ${need.baseCost}, {need.markupPct}% markup)</span>}</div>}
                    {need.vendorProductUrl && <div style={ST.orgDetail}><strong>Product:</strong> {need.vendorProductUrl}</div>}
                    <div style={ST.btnRow}>
  <button style={ST.btnMatch} onClick={() => startEdit(need)}>
    Edit need
  </button>

  {need.status !== 'open' && (
    <button
      style={ST.btnApprove}
      onClick={() => reopenNeedAndCancelCommitments(need)}
    >
      Reopen + cancel commitment
    </button>
  )}

  {need.status !== 'funded' && (
    <button style={ST.btnCancel} onClick={() => setNeedStatus(need, 'funded')}>
      Mark funded
    </button>
  )}

  {need.status !== 'paused' && (
    <button style={ST.btnCancel} onClick={() => setNeedStatus(need, 'paused')}>
      Pause
    </button>
  )}
</div>
                  </>
                )}
              </div>
            ))}
          </>
        )}

        {/* Active orgs */}
        {!loading && activeTab === 'active' && (
          <>
            {activeOrgs.length === 0 && <div style={ST.empty}>No active organizations yet.</div>}
            {activeOrgs.map(org => {
              const orgNeeds = allNeeds.filter(n => n.orgId === org.id);
              const isExpanded = expandedOrg === org.id;
              return (
                <div key={org.id} style={ST.card}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={ST.orgName}>{org.orgName}</div>
                      <div style={ST.orgMeta}>{org.orgType} &bull; {org.city}, {org.state}</div>
                      <div style={ST.orgDetail}><strong>Contact:</strong> {org.contactName} &bull; {org.email}</div>
                      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
                        <span style={{ ...ST.badge, background: '#d1fae5', color: '#065f46' }}>Active</span>
                        <span style={{ ...ST.badge, background: '#e0f2fe', color: '#075985' }}>{orgNeeds.length} need{orgNeeds.length !== 1 ? 's' : ''}</span>
                        <span style={{ ...ST.badge, background: '#d1fae5', color: '#065f46' }}>{orgNeeds.filter(n => n.status === 'funded').length} funded</span>
                        <span style={{ ...ST.badge, background: '#fef3c7', color: '#92400e' }}>{orgNeeds.filter(n => n.status === 'open').length} open</span>
                      </div>
                    </div>
                    <button style={{ ...ST.btnMatch, whiteSpace: 'nowrap' }} onClick={() => setExpandedOrg(isExpanded ? null : org.id)}>
                      {isExpanded ? 'Hide' : 'View details'}
                    </button>
                  </div>

                  {isExpanded && (
                    <div style={{ marginTop: '1.25rem', borderTop: '1px solid #eee', paddingTop: '1.25rem' }}>
                      <div style={{ marginBottom: '1.25rem', paddingBottom: '1.25rem', borderBottom: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                          <div style={{ fontSize: '0.9rem', fontWeight: 700 }}>Organization details</div>
                          {editingOrg !== org.id && (
                            <button style={{ ...ST.btnMatch, padding: '0.35rem 0.875rem', fontSize: '0.8rem' }}
                              onClick={() => { setEditingOrg(org.id); setOrgEditForm({ orgName: org.orgName || '', contactName: org.contactName || '', contactTitle: org.contactTitle || '', phone: org.phone || '', website: org.website || '', missionStatement: org.missionStatement || '', populationsServed: org.populationsServed || '', address: org.address || '', city: org.city || '', state: org.state || '', zip: org.zip || '', shippingAddress: org.shippingAddress || '', shippingCity: org.shippingCity || '', shippingState: org.shippingState || '', shippingZip: org.shippingZip || '', shippingContactName: org.shippingContactName || '', shippingInstructions: org.shippingInstructions || '', cfrCategories: org.cfrCategories || [], status: org.status || 'active' }); }}>
                              Edit org
                            </button>
                          )}
                        </div>
                        {editingOrg === org.id ? (
                          <>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Org name</label><input value={orgEditForm.orgName} onChange={e => setOrgEditForm(prev => ({ ...prev, orgName: e.target.value }))} style={ST.inp} /></div>
                              <div><label style={ST.lbl}>Status</label>
                                <select value={orgEditForm.status} onChange={e => setOrgEditForm(prev => ({ ...prev, status: e.target.value }))} style={ST.inp}>
                                  <option value="active">Active</option>
                                  <option value="pending">Pending</option>
                                  <option value="suspended">Suspended</option>
                                  <option value="rejected">Rejected</option>
                                </select>
                              </div>
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Contact name</label><input value={orgEditForm.contactName} onChange={e => setOrgEditForm(prev => ({ ...prev, contactName: e.target.value }))} style={ST.inp} /></div>
                              <div><label style={ST.lbl}>Phone</label><input value={orgEditForm.phone} onChange={e => setOrgEditForm(prev => ({ ...prev, phone: e.target.value }))} style={ST.inp} /></div>
                            </div>
                            <div style={ST.fullRow}><label style={ST.lbl}>Mission</label><textarea value={orgEditForm.missionStatement} onChange={e => setOrgEditForm(prev => ({ ...prev, missionStatement: e.target.value }))} style={{ ...ST.inp, minHeight: '70px', resize: 'vertical', fontFamily: 'inherit' }} /></div>
                            <div style={ST.fullRow}>
                              <label style={ST.lbl}>Community Priority (CFR)</label>
                              <AdminCfrPicker
                                selected={orgEditForm.cfrCategories || []}
                                onChange={val => setOrgEditForm(prev => ({ ...prev, cfrCategories: val }))}
                              />
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Mailing address</label><input value={orgEditForm.address} onChange={e => setOrgEditForm(prev => ({ ...prev, address: e.target.value }))} style={ST.inp} /></div>
                              <div><label style={ST.lbl}>City</label><input value={orgEditForm.city} onChange={e => setOrgEditForm(prev => ({ ...prev, city: e.target.value }))} style={ST.inp} /></div>
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>State</label><input value={orgEditForm.state} onChange={e => setOrgEditForm(prev => ({ ...prev, state: e.target.value }))} style={ST.inp} maxLength={2} /></div>
                              <div><label style={ST.lbl}>ZIP</label><input value={orgEditForm.zip} onChange={e => setOrgEditForm(prev => ({ ...prev, zip: e.target.value }))} style={ST.inp} maxLength={5} /></div>
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Shipping address</label><input value={orgEditForm.shippingAddress} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingAddress: e.target.value }))} style={ST.inp} /></div>
                              <div><label style={ST.lbl}>Shipping city</label><input value={orgEditForm.shippingCity} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingCity: e.target.value }))} style={ST.inp} /></div>
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Shipping state</label><input value={orgEditForm.shippingState} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingState: e.target.value }))} style={ST.inp} maxLength={2} /></div>
                              <div><label style={ST.lbl}>Shipping ZIP</label><input value={orgEditForm.shippingZip} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingZip: e.target.value }))} style={ST.inp} maxLength={5} /></div>
                            </div>
                            <div style={ST.grid2}>
                              <div><label style={ST.lbl}>Shipping contact</label><input value={orgEditForm.shippingContactName} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingContactName: e.target.value }))} style={ST.inp} /></div>
                              <div><label style={ST.lbl}>Delivery instructions</label><input value={orgEditForm.shippingInstructions} onChange={e => setOrgEditForm(prev => ({ ...prev, shippingInstructions: e.target.value }))} style={ST.inp} /></div>
                            </div>
                            <div style={ST.btnRow}>
                              <button style={ST.btnApprove} onClick={() => saveOrgEdit(org.id)}>Save org changes</button>
                              <button style={ST.btnCancel} onClick={() => { setEditingOrg(null); setOrgEditForm({}); }}>Cancel</button>
                            </div>
                          </>
                        ) : (
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem 1.5rem', fontSize: '0.875rem' }}>
                            <div><span style={{ color: '#888' }}>Contact: </span>{org.contactName}{org.contactTitle ? `, ${org.contactTitle}` : ''}</div>
                            <div><span style={{ color: '#888' }}>Phone: </span>{org.phone}</div>
                            <div><span style={{ color: '#888' }}>Email: </span>{org.email}</div>
                            <div><span style={{ color: '#888' }}>EIN: </span>{org.ein}</div>
                            <div><span style={{ color: '#888' }}>Mailing: </span>{org.address}, {org.city}, {org.state} {org.zip}</div>
                            <div><span style={{ color: '#888' }}>Shipping: </span>{org.shippingSameAsMailing ? 'Same as mailing' : `${org.shippingAddress}, ${org.shippingCity}`}</div>
                            {org.shippingInstructions && <div style={{ gridColumn: '1 / -1' }}><span style={{ color: '#888' }}>Delivery notes: </span>{org.shippingInstructions}</div>}
                            <div style={{ gridColumn: '1 / -1' }}><span style={{ color: '#888' }}>Mission: </span>{org.missionStatement}</div>
                            {(org.cfrCategories || []).length > 0 && (
                              <div style={{ gridColumn: '1 / -1' }}><span style={{ color: '#888' }}>Community priorities: </span>{org.cfrCategories.map(v => CFR_CATEGORIES.find(c => c.value === v)?.label).filter(Boolean).join(', ')}</div>
                            )}
                          </div>
                        )}
                      </div>
                      <OrgNeedAdminBlock
  org={org}
  orgNeeds={orgNeeds}
  addingNeedForOrg={addingNeedForOrg}
  setAddingNeedForOrg={setAddingNeedForOrg}
  adminNeedForm={adminNeedForm}
  setAdminNeedForm={setAdminNeedForm}
  addNeedForOrg={addNeedForOrg}
  resetAdminNeedForm={resetAdminNeedForm}
  needRowProps={needRowProps}
/>


                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}

        {/* Donors */}
        {!loading && activeTab === 'donors' && (
          <>
            {donors.length === 0 && <div style={ST.empty}>No donors yet.</div>}
            {donors.map(donor => (
              <div key={donor.id} style={ST.card}>
                <div style={ST.orgName}>{donor.firstName} {donor.lastName}</div>
                <div style={ST.orgMeta}>{donor.email} &bull; {donor.city}, {donor.state}</div>
                <div style={ST.orgDetail}><strong>Active subscriptions:</strong> {donor.activeSubCount || 0}</div>
              </div>
            ))}
          </>
        )}

{/* Waitlist */}
        {!loading && activeTab === 'waitlist' && (
          <>
            {waitlist.length === 0 && (
              <div style={ST.empty}>No waitlist signups yet.</div>
            )}
            {waitlist.length > 0 && (
              <div style={{ marginBottom: '1rem' }}>
                <div style={{ ...ST.card, background: '#f0fdf4',
                  border: '1px solid #bbf7d0' }}>
                  <div style={{ fontSize: '0.9rem', color: '#065f46',
                    fontWeight: 600 }}>
                    {waitlist.length} people waiting for launch
                  </div>
                  <div style={{ fontSize: '0.8rem', color: '#888',
                    marginTop: '0.25rem' }}>
                    Export emails when ready to launch
                  </div>
                  <button
                    style={{ ...ST.btnApprove, marginTop: '0.75rem',
                      fontSize: '0.8rem', padding: '0.4rem 0.875rem' }}
                    onClick={() => {
                      const emails = waitlist
                        .map(w => `${w.firstName} ${w.lastName || ''} <${w.email}>`)
                        .join('\n');
                      navigator.clipboard.writeText(emails);
                      alert('Email list copied to clipboard.');
                    }}
                  >
                    Copy all emails
                  </button>
                </div>
              </div>
            )}
            {waitlist
              .sort((a, b) => (b.createdAt?.seconds || 0) -
                (a.createdAt?.seconds || 0))
              .map(entry => (
              <div key={entry.id} style={ST.card}>
                <div style={ST.orgName}>
                  {entry.firstName} {entry.lastName || ''}
                </div>
                <div style={ST.orgMeta}>{entry.email}</div>
                <div style={ST.orgDetail}>
                  <strong>Signed up:</strong>{' '}
                  {entry.createdAt?.toDate?.()
                    ?.toLocaleDateString() || 'recently'}
                </div>
              </div>
            ))}
          </>
        )}

{/* Billing due */}
{!loading && activeTab === 'billing' && (
  <>
    {billingDue.length === 0 && (
      <div style={ST.empty}>No billing due today.</div>
    )}
    {billingDue.length > 0 && (
      <>
        <div style={{ ...ST.card, background: '#f0f4ff',
          border: '1px solid #dde3ff', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <label style={{ display: 'flex', alignItems: 'center',
              gap: '0.5rem', cursor: 'pointer', fontWeight: 600,
              fontSize: '0.9rem' }}>
              <input type="checkbox"
                checked={selectedDonors.size === billingDue.length}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedDonors(new Set(billingDue.map(d => d.donorId)));
                  } else {
                    setSelectedDonors(new Set());
                  }
                }} />
              Select all ({billingDue.length} donors)
            </label>
          </div>
          <button
            style={{ ...ST.btnApprove,
              opacity: selectedDonors.size === 0 || billingRunning ? 0.5 : 1 }}
            disabled={selectedDonors.size === 0 || billingRunning}
            onClick={runBilling}>
            {billingRunning
              ? 'Processing...'
              : `Run billing for ${selectedDonors.size} selected`}
          </button>
        </div>

        {billingDue.map(donor => {
          const result = billingResults[donor.donorId];
          const total = donor.subs.reduce((s, sub) => s + sub.pricePerCycle, 0);
          const isSelected = selectedDonors.has(donor.donorId);
          return (
            <div key={donor.donorId} style={{ ...ST.card,
              border: result?.success ? '1px solid #bbf7d0' :
                result?.error ? '1px solid #fecaca' : '1px solid #eee' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between',
                alignItems: 'flex-start', gap: '1rem' }}>
                <label style={{ display: 'flex', alignItems: 'center',
                  gap: '0.75rem', cursor: 'pointer', flex: 1 }}>
                  <input type="checkbox"
                    checked={isSelected}
                    onChange={e => {
                      const next = new Set(selectedDonors);
                      if (e.target.checked) next.add(donor.donorId);
                      else next.delete(donor.donorId);
                      setSelectedDonors(next);
                    }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: '1rem' }}>
                      {donor.donorName}
                    </div>
                    <div style={{ fontSize: '0.85rem', color: '#888' }}>
                      {donor.subs.length} item{donor.subs.length !== 1 ? 's' : ''} · 
                      Total: <strong style={{ color: '#1a1a1a' }}>
                        ${Math.ceil(total)}
                      </strong>
                    </div>
                  </div>
                </label>
                {result?.success && (
                  <span style={{ ...ST.badge, background: '#d1fae5',
                    color: '#065f46' }}>✓ Charged ${Math.ceil(result.amount)}</span>
                )}
                
{result?.error === 'No subscriptions due' && (
  <span style={{ ...ST.badge, background: '#f3f4f6',
    color: '#555' }}>Skipped</span>
)}

{result?.error && result.error !== 'No subscriptions due' && (
  <span style={{ ...ST.badge, background: '#fee2e2',
    color: '#991b1b' }}>✗ Failed</span>
)}

              </div>

              <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem',
                borderTop: '1px solid #f0f0f0' }}>
                {donor.subs.map(sub => (
                  <div key={sub.id} style={{ display: 'flex',
                    justifyContent: 'space-between', fontSize: '0.85rem',
                    padding: '0.35rem 0', borderBottom: '0.5px solid #f5f5f5' }}>
                    <span style={{ color: '#444' }}>{sub.itemName}
                      <span style={{ color: '#888', marginLeft: '0.5rem' }}>
                        · {sub.orgName}
                      </span>
                    </span>
                    <span style={{ color: '#1e3a5f', fontWeight: 600 }}>
                      ${Math.ceil(sub.pricePerCycle)}
                    </span>
                  </div>
                ))}
                {donor.subs[0]?.nextBillingDate && (
                  <div style={{ fontSize: '0.8rem', color: '#888',
                    marginTop: '0.5rem' }}>
                    Due: {donor.subs[0].nextBillingDate?.toDate?.()
                      ?.toLocaleDateString() || 'today'}
                  </div>
                )}
              </div>

              {result?.error && (
  <div style={{ marginTop: '0.75rem', display: 'flex',
    gap: '0.75rem', alignItems: 'center' }}>
    <span style={{ fontSize: '0.85rem',
      color: result.error === 'No subscriptions due' ? '#555' : '#dc2626' }}>
      {result.error}
    </span>

    {result.error !== 'No subscriptions due' && (
      <button style={{ ...ST.btnReject, fontSize: '0.8rem',
        padding: '0.35rem 0.875rem' }}
        onClick={() => {
          const donorData = donors.find(d => d.id === donor.donorId);
          if (donorData) sendPaymentReminder(
            donor.donorId,
            donorData.email,
            donorData.firstName
          );
        }}>
        Send reminder
      </button>
    )}
  </div>
)}

            </div>
          );
        })}
      </>
    )}
  </>
)}

{/* Orders needed */}
{!loading && activeTab === 'orders' && (
  <>
    {ordersNeeded.length === 0 && (
      <div style={ST.empty}>No orders currently needed.</div>
    )}

    {ordersNeeded.length > 0 && (
      <>
        <div style={{ ...ST.card, background: '#f0fdf4',
          border: '1px solid #bbf7d0', display: 'flex',
          justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center',
              gap: '0.5rem', cursor: 'pointer', fontWeight: 600,
              fontSize: '0.9rem' }}>
              <input
                type="checkbox"
                checked={markedOrdered.size === ordersNeeded.length}
                onChange={e => {
                  if (e.target.checked) {
                    setMarkedOrdered(new Set(ordersNeeded.map(o => o.id)));
                  } else {
                    setMarkedOrdered(new Set());
                  }
                }}
              />
              Select all ({ordersNeeded.length} items)
            </label>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <span style={{ fontSize: '0.85rem', color: '#555' }}>Group by</span>
              <select
                value={ordersGroupBy}
                onChange={(e) => setOrdersGroupBy(e.target.value)}
                style={ST.inp}
              >
                <option value="org">Organization</option>
                <option value="dueDate">Delivery due date</option>
              </select>
            </div>
          </div>

          <button
            style={{ ...ST.btnApprove,
              opacity: markedOrdered.size === 0 || orderingItems ? 0.5 : 1 }}
            disabled={markedOrdered.size === 0 || orderingItems}
            onClick={() => {
              const selected = ordersNeeded.filter(o => markedOrdered.has(o.id));
              markAsOrdered(selected);
            }}
          >
            {orderingItems ? 'Saving...' : `Mark ${markedOrdered.size} as ordered`}
          </button>
        </div>

        {(() => {
          const fmt = (ts) => {
            if (!ts) return '—';
            const d = ts?.toDate ? ts.toDate() : new Date(ts);
            return d.toLocaleDateString('en-US', {
              month: 'numeric',
              day: 'numeric',
              year: '2-digit'
            });
          };

          const groups = {};

          ordersNeeded.forEach((sub) => {
            const key = ordersGroupBy === 'dueDate'
              ? fmt(sub.deliveryDueDate)
              : sub.orgId;

            if (!groups[key]) {
              groups[key] = {
                label: ordersGroupBy === 'dueDate' ? `Delivery due ${fmt(sub.deliveryDueDate)}` : sub.orgName,
                orgId: sub.orgId,
                items: []
              };
            }

            groups[key].items.push(sub);
          });

          return Object.entries(groups).map(([groupKey, group]) => {
            const org = activeOrgs.find(o => o.id === group.orgId);

            return (
              <div key={groupKey} style={ST.card}>
                <div style={ST.orgName}>{group.label}</div>

                {ordersGroupBy === 'org' && org && (
                  <div style={ST.orgMeta}>
                    Ship to: {org.shippingAddress || org.address},{' '}
                    {org.shippingCity || org.city},{' '}
                    {org.shippingState || org.state}{' '}
                    {org.shippingZip || org.zip}
                    {org.shippingContactName && ` · Attn: ${org.shippingContactName}`}
                    {org.shippingInstructions && ` · ${org.shippingInstructions}`}
                  </div>
                )}

                {group.items
                  .sort((a, b) => {
                    const aTime = a.deliveryDueDate?.toDate?.()?.getTime?.() || 0;
                    const bTime = b.deliveryDueDate?.toDate?.()?.getTime?.() || 0;
                    return aTime - bTime;
                  })
                  .map((sub) => (
                    <div key={sub.id} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.75rem 0',
                      borderBottom: '0.5px solid #f0f0f0'
                    }}>
                      <input
                        type="checkbox"
                        checked={markedOrdered.has(sub.id)}
                        onChange={e => {
                          const next = new Set(markedOrdered);
                          if (e.target.checked) next.add(sub.id);
                          else next.delete(sub.id);
                          setMarkedOrdered(next);
                        }}
                      />

                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '0.92rem', fontWeight: 600 }}>
                          {sub.itemName}
                        </div>

                        <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '0.15rem' }}>
                          {sub.orgName} · Qty: {sub.quantityPerCycle || 1} · {sub.frequency}
                        </div>

                        <div style={{ fontSize: '0.8rem', color: '#555', marginTop: '0.2rem' }}>
                          Billed: {fmt(sub.lastBilledDate)} ·
                          Order due: {fmt(sub.orderDueDate)} ·
                          Delivery due: {fmt(sub.deliveryDueDate)}
                        </div>
                      </div>

                      {sub.vendorProductUrl ? (
                        <a
                          href={sub.vendorProductUrl}
                          target="_blank"
                          rel="noreferrer"
                          style={{ fontSize: '0.85rem', color: '#1e3a5f',
                            fontWeight: 600, whiteSpace: 'nowrap' }}
                        >
                          Order link →
                        </a>
                      ) : (
                        <span style={{ fontSize: '0.85rem', color: '#888' }}>
                          No link
                        </span>
                      )}
                    </div>
                  ))}
              </div>
            );
          });
        })()}
      </>
    )}
  </>
)}

{/* Ordered / awaiting delivery */}
{!loading && activeTab === 'ordered' && (
  <>
    {orderedItems.length === 0 && (
      <div style={ST.empty}>No ordered or shipped items awaiting delivery.</div>
    )}

    {orderedItems.length > 0 && (
      orderedItems
        .sort((a, b) => {
          const aTime = a.targetDeliveryDate?.toDate?.()?.getTime?.() || 0;
          const bTime = b.targetDeliveryDate?.toDate?.()?.getTime?.() || 0;
          return aTime - bTime;
        })
        .map((item) => {
          const fmt = (ts) => {
            if (!ts) return '—';
            const d = ts?.toDate ? ts.toDate() : new Date(ts);
            return d.toLocaleDateString('en-US', {
              month: 'numeric',
              day: 'numeric',
              year: '2-digit'
            });
          };

          return (
            <div key={item.id} style={ST.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.25rem' }}>
                    {item.itemName}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#888', marginBottom: '0.35rem' }}>
                    {item.orgName} · Qty: {item.quantityPerCycle || 1} · {item.frequency}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#555', marginBottom: '0.25rem' }}>
                    Ordered: {fmt(item.orderedAt)} · Delivery due: {fmt(item.targetDeliveryDate)}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#555' }}>
                    Ship to: {item.shippingAddress}, {item.shippingCity}, {item.shippingState} {item.shippingZip}
                    {item.shippingContactName ? ` · Attn: ${item.shippingContactName}` : ''}
                  </div>


                  {item.status === 'shipped' && (
  <div style={{ fontSize: '0.85rem', color: '#065f46', marginTop: '0.35rem' }}>
    Shipped via {item.carrier}
    {item.trackingNumber ? ` · ${item.trackingNumber}` : ''}
    {item.trackingUrl && (
      <>
        {' · '}
        <a href={item.trackingUrl} target="_blank" rel="noreferrer">
          Track package →
        </a>
      </>
    )}
  </div>
)}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'flex-end' }}>
                  {item.vendorProductUrl ? (
                    <a
                      href={item.vendorProductUrl}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        fontSize: '0.85rem',
                        color: '#1e3a5f',
                        fontWeight: 600,
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Order link →
                    </a>
                  ) : (
                    <span style={{ fontSize: '0.85rem', color: '#888' }}>
                      No link
                    </span>
                  )}

                  {item.status === 'ordered' && (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
    marginBottom: '0.5rem',
    minWidth: '220px'
  }}>
    <input
      placeholder="Carrier, e.g. UPS"
      value={trackingForm[item.id]?.carrier || ''}
      onChange={e => setTrackingForm(prev => ({
        ...prev,
        [item.id]: {
          ...(prev[item.id] || {}),
          carrier: e.target.value
        }
      }))}
      style={ST.inp}
    />

    <input
      placeholder="Tracking number"
      value={trackingForm[item.id]?.trackingNumber || ''}
      onChange={e => setTrackingForm(prev => ({
        ...prev,
        [item.id]: {
          ...(prev[item.id] || {}),
          trackingNumber: e.target.value
        }
      }))}
      style={ST.inp}
    />

    <input
      placeholder="Tracking URL optional"
      value={trackingForm[item.id]?.trackingUrl || ''}
      onChange={e => setTrackingForm(prev => ({
        ...prev,
        [item.id]: {
          ...(prev[item.id] || {}),
          trackingUrl: e.target.value
        }
      }))}
      style={ST.inp}
    />

    <button
      style={{ ...ST.btnMatch, padding: '0.4rem 0.9rem', fontSize: '0.82rem' }}
      disabled={!!savingTracking[item.id]}
      onClick={() => saveTracking(item.id, item.subscriptionId)}
    >
      {savingTracking[item.id] ? 'Saving...' : 'Add tracking'}
    </button>
  </div>
)}

<button
  style={{ ...ST.btnApprove, padding: '0.4rem 0.9rem', fontSize: '0.82rem' }}
  onClick={() => markAsDelivered(item.id, item.subscriptionId, item.needId)}
>
  Mark delivered
</button>

                </div>
              </div>
            </div>
          );
        })
    )}
  </>
)}

{/* Invite Org */}
{!loading && activeTab === 'invite' && (
  <div style={ST.card}>
    <div style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.75rem' }}>
      Invite Organization
    </div>

    <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '1rem', lineHeight: 1.5 }}>
      Create an organization profile first, then send the contact an invite link so they can create their own login.
    </div>

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Organization name</label>
        <input
          value={inviteForm.orgName}
          onChange={e => setInviteForm(prev => ({ ...prev, orgName: e.target.value }))}
          style={ST.inp}
          placeholder="Springfield Rescue Mission"
        />
      </div>

      <div>
        <label style={ST.lbl}>Organization type</label>
        <select
          value={inviteForm.orgType}
          onChange={e => setInviteForm(prev => ({ ...prev, orgType: e.target.value }))}
          style={ST.inp}
        >
          <option value="homeless_shelter">Homeless shelter</option>
          <option value="youth_center">Youth center</option>
          <option value="diaper_bank">Diaper bank</option>
          <option value="domestic_violence">Domestic violence shelter</option>
          <option value="transitional_housing">Transitional housing</option>
          <option value="food_pantry">Food pantry</option>
          <option value="family_services">Family services</option>
          <option value="other">Other nonprofit</option>
        </select>
      </div>
    </div>

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Contact name</label>
        <input
          value={inviteForm.contactName}
          onChange={e => setInviteForm(prev => ({ ...prev, contactName: e.target.value }))}
          style={ST.inp}
          placeholder="Jane Smith"
        />
      </div>

      <div>
        <label style={ST.lbl}>Contact title</label>
        <input
          value={inviteForm.contactTitle}
          onChange={e => setInviteForm(prev => ({ ...prev, contactTitle: e.target.value }))}
          style={ST.inp}
          placeholder="Executive Director"
        />
      </div>
    </div>

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Email for invite</label>
        <input
          type="email"
          value={inviteForm.email}
          onChange={e => setInviteForm(prev => ({ ...prev, email: e.target.value }))}
          style={ST.inp}
          placeholder="contact@org.org"
        />
      </div>

      <div>
        <label style={ST.lbl}>Phone</label>
        <input
          value={inviteForm.phone}
          onChange={e => setInviteForm(prev => ({ ...prev, phone: e.target.value }))}
          style={ST.inp}
          placeholder="(417) 555-0100"
        />
      </div>
    </div>

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Website</label>
        <input
          value={inviteForm.website}
          onChange={e => setInviteForm(prev => ({ ...prev, website: e.target.value }))}
          style={ST.inp}
          placeholder="https://example.org"
        />
      </div>

      <div>
        <label style={ST.lbl}>EIN</label>
        <input
          value={inviteForm.ein}
          onChange={e => setInviteForm(prev => ({ ...prev, ein: e.target.value }))}
          style={ST.inp}
          placeholder="XX-XXXXXXX"
        />
      </div>
    </div>

    <div style={ST.fullRow}>
      <label style={ST.lbl}>Mission statement</label>
      <textarea
        value={inviteForm.missionStatement}
        onChange={e => setInviteForm(prev => ({ ...prev, missionStatement: e.target.value }))}
        style={{ ...ST.inp, minHeight: '80px', resize: 'vertical', fontFamily: 'inherit' }}
        placeholder="Briefly describe the organization’s mission..."
      />
    </div>

    <div style={ST.fullRow}>
      <label style={ST.lbl}>Populations served</label>
      <input
        value={inviteForm.populationsServed}
        onChange={e => setInviteForm(prev => ({ ...prev, populationsServed: e.target.value }))}
        style={ST.inp}
        placeholder="Families in crisis, youth, shelter residents, etc."
      />
    </div>

    <div style={ST.fullRow}>
      <label style={ST.lbl}>Community Priority (CFR) — optional, up to 3</label>
      <AdminCfrPicker
        selected={inviteForm.cfrCategories || []}
        onChange={val => setInviteForm(prev => ({ ...prev, cfrCategories: val }))}
      />
    </div>

    <div style={{ fontSize: '0.95rem', fontWeight: 700, margin: '1.25rem 0 0.75rem' }}>
      Mailing address
    </div>

    <div style={ST.fullRow}>
      <label style={ST.lbl}>Street address</label>
      <input
        value={inviteForm.address}
        onChange={e => setInviteForm(prev => ({ ...prev, address: e.target.value }))}
        style={ST.inp}
        placeholder="123 Main Street"
      />
    </div>

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>City</label>
        <input
          value={inviteForm.city}
          onChange={e => setInviteForm(prev => ({ ...prev, city: e.target.value }))}
          style={ST.inp}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label style={ST.lbl}>State</label>
          <input
            value={inviteForm.state}
            onChange={e => setInviteForm(prev => ({ ...prev, state: e.target.value }))}
            style={ST.inp}
            maxLength={2}
          />
        </div>

        <div>
          <label style={ST.lbl}>ZIP</label>
          <input
            value={inviteForm.zip}
            onChange={e => setInviteForm(prev => ({ ...prev, zip: e.target.value }))}
            style={ST.inp}
            maxLength={5}
          />
        </div>
      </div>
    </div>

    <div style={{ margin: '1rem 0' }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={inviteForm.shippingSameAsMailing}
          onChange={e => setInviteForm(prev => ({ ...prev, shippingSameAsMailing: e.target.checked }))}
        />
        Shipping address is same as mailing address
      </label>
    </div>

    {!inviteForm.shippingSameAsMailing && (
      <>
        <div style={{ fontSize: '0.95rem', fontWeight: 700, margin: '1.25rem 0 0.75rem' }}>
          Shipping address
        </div>

        <div style={ST.fullRow}>
          <label style={ST.lbl}>Shipping street address</label>
          <input
            value={inviteForm.shippingAddress}
            onChange={e => setInviteForm(prev => ({ ...prev, shippingAddress: e.target.value }))}
            style={ST.inp}
          />
        </div>

        <div style={ST.grid2}>
          <div>
            <label style={ST.lbl}>Shipping city</label>
            <input
              value={inviteForm.shippingCity}
              onChange={e => setInviteForm(prev => ({ ...prev, shippingCity: e.target.value }))}
              style={ST.inp}
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
            <div>
              <label style={ST.lbl}>Shipping state</label>
              <input
                value={inviteForm.shippingState}
                onChange={e => setInviteForm(prev => ({ ...prev, shippingState: e.target.value }))}
                style={ST.inp}
                maxLength={2}
              />
            </div>

            <div>
              <label style={ST.lbl}>Shipping ZIP</label>
              <input
                value={inviteForm.shippingZip}
                onChange={e => setInviteForm(prev => ({ ...prev, shippingZip: e.target.value }))}
                style={ST.inp}
                maxLength={5}
              />
            </div>
          </div>
        </div>
      </>
    )}

    <div style={ST.grid2}>
      <div>
        <label style={ST.lbl}>Shipping contact</label>
        <input
          value={inviteForm.shippingContactName}
          onChange={e => setInviteForm(prev => ({ ...prev, shippingContactName: e.target.value }))}
          style={ST.inp}
          placeholder="Defaults to contact name"
        />
      </div>

      <div>
        <label style={ST.lbl}>Delivery instructions</label>
        <input
          value={inviteForm.shippingInstructions}
          onChange={e => setInviteForm(prev => ({ ...prev, shippingInstructions: e.target.value }))}
          style={ST.inp}
          placeholder="Leave at front desk, ring bell, etc."
        />
      </div>
    </div>

    <div style={ST.btnRow}>
      <button
        style={{ ...ST.btnApprove, opacity: creatingInvite ? 0.6 : 1 }}
        disabled={creatingInvite}
        onClick={createOrgInvite}
      >
        {creatingInvite ? 'Creating invite...' : 'Create org + send invite'}
      </button>
    </div>

    {lastInviteResult?.inviteUrl && (
      <div style={{
        marginTop: '1.25rem',
        padding: '1rem',
        borderRadius: '10px',
        background: '#f0fdf4',
        border: '1px solid #bbf7d0'
      }}>
        <div style={{ fontWeight: 700, color: '#065f46', marginBottom: '0.5rem' }}>
          Invite created
        </div>

        <div style={{ fontSize: '0.85rem', color: '#444', marginBottom: '0.75rem', wordBreak: 'break-all' }}>
          {lastInviteResult.inviteUrl}
        </div>

        <button
          style={{ ...ST.btnMatch, padding: '0.4rem 0.9rem', fontSize: '0.82rem' }}
          onClick={() => {
            navigator.clipboard.writeText(lastInviteResult.inviteUrl);
            alert('Invite link copied.');
          }}
        >
          Copy invite link
        </button>
      </div>
    )}
  </div>
)}

{/* Adopted Sponsorships */}
{!loading && activeTab === 'sponsorships' && (
  <>
    {sponsorshipCommitments.length === 0 && (
      <div style={ST.empty}>No sponsorship commitments yet.</div>
    )}

    {sponsorshipCommitments
      .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0))
      .map(commitment => (
        <div key={commitment.id} style={ST.card}>
          <div style={ST.orgName}>{commitment.needTitle}</div>

          <div style={ST.orgMeta}>
            {commitment.orgName} · Status: {commitment.status || 'pending_forward'}
          </div>

          <div style={ST.orgDetail}>
            <strong>Donor:</strong> {commitment.donorName || '—'} · {commitment.donorEmail || '—'}
            {commitment.donorPhone ? ` · ${commitment.donorPhone}` : ''}
          </div>

          {commitment.messageToOrg && (
            <div style={ST.orgDetail}>
              <strong>Message:</strong> {commitment.messageToOrg}
            </div>
          )}

          <div style={ST.btnRow}>
            <button
              style={ST.btnMatch}
              onClick={() => {
                const subject = encodeURIComponent(
                  `Sponsorship interest: ${commitment.needTitle}`
                );

                const body = encodeURIComponent(
`Hello,

A donor has expressed interest in this sponsorship opportunity on SomebodyGives.

Organization: ${commitment.orgName}
Sponsorship: ${commitment.needTitle}

Donor:
${commitment.donorName || ''}
${commitment.donorEmail || ''}
${commitment.donorPhone || ''}

Message:
${commitment.messageToOrg || 'No message provided.'}

The donor agreed that SomebodyGives may share this contact information with your organization so you can follow up directly.

Thank you.`
                );

                window.location.href = `mailto:?subject=${subject}&body=${body}`;
              }}
            >
              Create email
            </button>

            {commitment.status !== 'forwarded_to_org' && (
              <button
                style={ST.btnApprove}
                onClick={async () => {
                  await updateDoc(doc(db, 'sponsorshipCommitments', commitment.id), {
                    status: 'forwarded_to_org',
                    forwardedAt: serverTimestamp(),
                    updatedAt: serverTimestamp()
                  });
                  await fetchData();
                }}
              >
                Mark forwarded
              </button>
            )}
          </div>
        </div>
      ))}
  </>
)}

{/* Admin Tools */}
{!loading && activeTab === 'tools' && (
  <div style={ST.card}>
    <div style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.75rem' }}>
      Admin Tools (Testing Only)
    </div>

    <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '1rem' }}>
      This will delete ALL subscriptions and reset ALL needs to open.
      Use only for testing.
    </div>

    <button
      style={{
        background: '#dc2626',
        color: 'white',
        border: 'none',
        padding: '0.75rem 1.25rem',
        borderRadius: '8px',
        fontWeight: 700,
        cursor: 'pointer'
      }}
      onClick={async () => {
        const confirmed = window.confirm(
          "This will delete ALL subscriptions and reset ALL needs to OPEN.\n\nContinue?"
        );

        if (!confirmed) return;

        try {
          const functions = getFunctions();
          const resetFn = httpsCallable(functions, 'resetTestingData');

          const result = await resetFn();

          alert(
            `Reset complete\n\nDeleted subscriptions: ${result.data.deletedSubscriptions}\nDeleted orders: ${result.data.deletedOrders}\nReset needs: ${result.data.resetNeeds}`
          );

          window.location.reload(); // quick refresh
        } catch (err) {
          console.error("Reset failed:", err);
          alert(`Reset failed: ${err.message}`);
        }
      }}
    >
      Delete All Subscriptions + Reset Needs
    </button>

  </div>
)}

{/* Copy Needs */}
{!loading && activeTab === 'copyNeeds' && (
  <div style={ST.card}>
    <CopyNeedsTool />
  </div>
)}

{/* Import Wishlist */}
{!loading && activeTab === 'importWishlist' && (
  <div style={ST.card}>
    <ImportWishlist />
  </div>
)}

      </main>
    </div>
  );
}

export default AdminDashboard;